import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QSubWSMessage } from '@qtek/core/websockets-core';
import {
  AiSummaryFilters,
  EntityMeta,
  FinalizeSummaryRequest,
  GenerateSummaryResponse,
  Message,
  Note,
  NoteValue,
  NoteWriteValue,
} from '@qtek/shared/models';

export const NoteActions = createActionGroup({
  source: 'Note',
  events: {
    // General Note Actions
    'Connect Note': props<{
      mysid: string;
      q?: object[];
      prms?: Record<string, string>;
      view?: string;
      cmd?: string;
    }>(),
    'Disconnect Note': props<{ mysid: string }>(),
    'Query Notes': props<{
      mysid: string;
      q?: QSubWSMessage[];
      prms?: Record<string, string>;
      view?: string;
    }>(),
    'Create Note': props<{
      mysid: string;
      refId: string;
      note: NoteWriteValue;
    }>(),
    'Create Note Success': props<{
      note: Note;
      mysid: string;
      message: Message;
    }>(),
    'Create Note Failure': props<{ error: any }>(),
    'Get Notes': emptyProps(),
    'Get Notes Success': props<{
      mysid: string;
      notes: Note[];
      meta: EntityMeta;
    }>(),
    'Get Notes Failure': props<{ error: any }>(),
    'Update Note': props<{ mysid: string; note: NoteWriteValue }>(),
    'Update Note Success': props<{
      note: Note;
      mysid: string;
      message: Message;
    }>(),
    'Update Note Failure': props<{ error: any }>(),
    'Delete Note': props<{ id: string; mysid: string }>(),
    'Delete Note Success': props<{
      id: string;
      mysid: string;
      message: Message;
    }>(),
    'Delete Note Failure': props<{ error: any }>(),

    // Note User Actions
    'Connect Note User': props<{
      mysid: string;
      q?: object[];
      prms?: Record<string, string>;
      view?: string;
    }>(),
    'Disconnect Note User': props<{ mysid: string }>(),
    'Create Note User': props<{
      mysid: string;
      refId: string;
      note: NoteWriteValue;
    }>(),
    'Create Note User Success': props<{
      note: Note;
      mysid: string;
      message: Message;
    }>(),
    'Create Note User Failure': props<{ error: any }>(),
    'Get Notes User': emptyProps(),
    'Get Notes User Success': props<{
      mysid: string;
      notes: Note[];
      meta: EntityMeta;
    }>(),
    'Get Notes User Failure': props<{ error: any }>(),
    'Update Note User': props<{ mysid: string; note: NoteWriteValue }>(),
    'Update Note User Success': props<{
      note: Note;
      mysid: string;
      message: Message;
    }>(),
    'Update Note User Failure': props<{ error: any }>(),
    'Delete Note User': props<{ id: string; mysid: string }>(),
    'Delete Note User Success': props<{
      id: string;
      mysid: string;
      message: Message;
    }>(),
    'Delete Note User Failure': props<{ error: any }>(),

    // Note Company Actions
    'Connect Note Company': props<{
      mysid: string;
      q?: object[];
      prms?: Record<string, string>;
      view?: string;
    }>(),
    'Disconnect Note Company': props<{ mysid: string }>(),
    'Create Note Company': props<{
      mysid: string;
      refId: string;
      note: NoteWriteValue;
    }>(),
    'Create Note Company Success': props<{
      note: Note;
      mysid: string;
      message: Message;
    }>(),
    'Create Note Company Failure': props<{ error: any }>(),
    'Get Notes Company': emptyProps(),
    'Get Notes Company Success': props<{
      mysid: string;
      notes: Note[];
      meta: EntityMeta;
    }>(),
    'Get Notes Company Failure': props<{ error: any }>(),
    'Update Note Company': props<{ mysid: string; note: NoteWriteValue }>(),
    'Update Note Company Success': props<{
      note: Note;
      mysid: string;
      message: Message;
    }>(),
    'Update Note Company Failure': props<{ error: any }>(),
    'Delete Note Company': props<{ id: string; mysid: string }>(),
    'Delete Note Company Success': props<{
      id: string;
      mysid: string;
      message: Message;
    }>(),
    'Delete Note Company Failure': props<{ error: any }>(),

    // ---------------------------------------------------------------------------
    // AI Summary Actions
    // ---------------------------------------------------------------------------
    'Generate Summary': props<{
      noteIds: string[];
      filters?: AiSummaryFilters;
    }>(),
    'Generate Summary Success': props<{ response: GenerateSummaryResponse }>(),
    'Generate Summary Failure': props<{ error: any }>(),
    'Finalize Summary': props<{ request: FinalizeSummaryRequest }>(),
    'Finalize Summary Success': emptyProps(),
    'Finalize Summary Failure': props<{ error: any }>(),
    'Clear Summary': emptyProps(),
  },
});
